import Vue from 'vue'
import App from './App.vue'
import router from "./router";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);


// 全局样式

import "./static/css/style.min.css";

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')